import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=e610c720&scoped=true&"
import script from "./VideoPreview.vue?vue&type=script&lang=js&"
export * from "./VideoPreview.vue?vue&type=script&lang=js&"
import style0 from "./VideoPreview.vue?vue&type=style&index=0&id=e610c720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e610c720",
  null
  
)

export default component.exports